import { render, staticRenderFns } from "./Semesters.vue?vue&type=template&id=5c30cd1f&"
import script from "./Semesters.vue?vue&type=script&lang=js&"
export * from "./Semesters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports